const normalise = (value) => String(value || "").trim().toLowerCase();
const hasPermission = (permissions, permission) =>
  Array.isArray(permissions) &&
  permissions.some((item) => normalise(item) === normalise(permission));

export const isMyPaymentsAdviser = (role, permissions = []) =>
  ["adviser", "advisers"].includes(normalise(role)) &&
  hasPermission(permissions, "Can View Payments");

export const isMyPaymentsStaff = (role, permissions = []) =>
  normalise(role) === "staff" &&
  ["Administrator", "Tech", "Finance"].some((permission) =>
    hasPermission(permissions, permission),
  );

export const canViewMyPaymentsGroup = (role, permissions = []) =>
  ["adviser", "advisers"].includes(normalise(role)) &&
  hasPermission(permissions, "Can View Group Payments");

export const canAccessMyPayments = (role, permissions = []) =>
  isMyPaymentsAdviser(role, permissions) ||
  isMyPaymentsStaff(role, permissions);
